import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const SUMTOTALJOBSDIFFINVANY_LAYER_ID = 'sumTotalJobsDiffInvAnyLayer';

const layerConfig = {
  title: 'Sum Total Jobs Diff',
};

function SumTotalJobsDiffInvAnyLayer() {
  const dispatch = useDispatch();
  const { sumTotalJobsDiffInvAnyLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, sumTotalJobsDiffInvAnyLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (sumTotalJobsDiffInvAnyLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SUMTOTALJOBSDIFFINVANY_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: sumTotalJobsDiffInvAnyLayer.visible,
      opacity: sumTotalJobsDiffInvAnyLayer.opacity,
      getFillColor: colorBins({
        attr: 'sum_total_jobs_diff',
        domain: [-10317, -10, -1, 0, 5, 10000, 137831],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SUMTOTALJOBSDIFFINVANY_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['sum_total_jobs_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default SumTotalJobsDiffInvAnyLayer;
